var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var TargetForSelect = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function(){
        if(this.props.isDisabled && !this.props.isChecked){
            this.props.onTargetChange(this.props.target);
        }
    },

    handleTargetChange: function(event){
        if(event.target.checked){
            this.props.onTargetChange(this.props.target);
        }
    },

    render: function(){
        return (
            <li>
                <input id={'target_' + this.props.target._id} type="radio" name="target" checked={this.props.isChecked} disabled={this.props.isDisabled} value={this.props.target._id} onChange={this.handleTargetChange} />
                <label htmlFor={'target_' + this.props.target._id}>{this.props.target.name}</label>
            </li>
        );
    }
});

module.exports = TargetForSelect;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/targetForSelect.jsx